export const Share2Icon = ({ ...props }) => {
  return (
    <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m0 0h48v48h-48z" />
      <g stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" {...props}>
        <path d="m26 6h16v16" />
        <path d="m42 29.4737v9.5263c0 1.6569-1.3431 3-3 3h-30c-1.65685 0-3-1.3431-3-3v-30c0-1.65685 1.34315-3 3-3h9" />
        <path d="m25.8 22.2 15.3-15.30001" />
      </g>
    </svg>
  );
};
